import React from 'react';
import './HomePage.css';
import Header from '../components/Header/Header';
import Services from '../components/Services/Services';
import About from '../components/About/About';
import Testimonials from '../components/Testimonials/Testimonials';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <Header />
      <main className="homepage__main">
        <Services />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;